module.exports = __webpack_public_path__ + "img/airpod-max.6893de54.png";